<script>
	// @ts-nocheck

	import { onMount } from 'svelte';
	import { variables } from '$lib/variables';
	import { page } from '$app/stores';
	import { error } from '@sveltejs/kit';
	import Loader from '../Loader.svelte';
	let errorcode = '';
	let inputs = [];
	let code = ['', '', '', ''];
	export let phone, codeinp;
	// Функция для автоматического перемещения фокуса на следующее поле
	function moveFocus(currentIndex, event) {
		// Перемещение фокуса вперед при вводе
		if (
			event.key !== 'Backspace' &&
			event.target.value.length >= 1 &&
			currentIndex < code.length - 1
		) {
			inputs[currentIndex + 1].focus();
		}

		// Перемещение фокуса назад и стирание предыдущего значения при нажатии Backspace
		if (event.key === 'Backspace' && currentIndex > 0) {
			if (code[currentIndex] === '') {
				// Если текущее поле уже пустое, перейти к предыдущему и очистить его
				code[currentIndex - 1] = '';
				inputs[currentIndex - 1].focus();
			}
		}
	}

	// Функция для обработки ввода и обновления массива code
	function updateCode(index, value) {
		code[index] = value.replace(/\D/g, ''); // Удаляем все нечисловые символы
	}

	// Отслеживаем изменение code и выполняем действия после заполнения всех полей
	$: filled = code.every((c) => c !== '');
	let load;
	async function SendAuth() {
		load = true;
		let senddata = {
			phone: phone,
			code: code.join('')
		};
		let referral_code = localStorage.getItem('referral_code') || '';
		let url = `${variables.basePathApi}/users/auth/sms-verify/?referral_code=${referral_code}`;

		const res = await fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(senddata)
		});
		if (res.status == 200) {
			const json = await res.json();

			const resLogin = await fetch('/auth/login', {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(json)
			});
			if (resLogin.status == 200) {
			}
			errorcode = '';
			// Cookies.set('access', json.access, { expires: 1 });
			// Cookies.set('refresh', json.refresh, { expires: 1 });
			setTimeout(() => {
				let urlred = $page.url.searchParams.get('pathname') || '/';
				if ($page.url.searchParams.get('open_basket')) {
					urlred = `${urlred}?open_basket=1`;
				}
				if ($page.url.pathname === '/auth/sign-in') {
					urlred = '/profile';
				}
				load = false;
				location.href = urlred;
			}, 200);
		} else if (res.status == 400) {
			let dat = await res.json();
			code = ['', '', '', ''];
			inputs[0].focus();
			load = false;
			return (errorcode = dat.detail);
		} else {
			code = ['', '', '', ''];
			inputs[0].focus();
			load = false;
			load = false;
			alert('Ошибка сервера');
		}
	}
	const SendPhone = async () => {
		SendAuth();
	};
	$: if (filled) {
		// Здесь можно выполнить какие-либо действия после заполнения всех полей, например, отправить код на сервер

		SendPhone();
	}
	let firstInput;
	onMount(() => {
		if (inputs[0]) {
			inputs[0].focus();
		}
	});
</script>

<form id="otp-form" class="relative">
	{#if load}
		<Loader />
	{/if}
	<div class="flex items-center justify-center gap-3">
		{#each code as value, index}
			<input
				bind:this={inputs[index]}
				bind:value={code[index]}
				on:input={() => updateCode(index, code[index])}
				on:keyup={(event) => moveFocus(index, event)}
				pattern="[0-9]*"
				class="w-14 h-14 text-center text-2xl font-extrabold text-slate-900 bg-slate-100 border border-transparent hover:border-slate-200 appearance-none rounded p-4 outline-none focus:bg-white focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
				maxlength="1"
				inputmode="numeric"
				type="tel"
			/>
		{/each}
	</div>
	{#if errorcode}
		<div class="max-w-[260px] mx-auto mt-4 text-sm text-red-500">
			{errorcode}
		</div>
	{/if}
	<div class="max-w-[260px] mx-auto mt-4 text-sm text-gray-600">
		Ожидайте звонка от оператора, который сообщит вам четырёхзначный код.
	</div>
	<div class="max-w-[260px] mx-auto mt-4 text-sm text-gray-600">
		<button
			class="text-indigo-600"
			on:click={() => {
				codeinp = false;
			}}>Не поступил звонок?</button
		>
	</div>
</form>
